/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Share_FailedInputs */

const en_us2_workout_share_share_failed = /** @type {(inputs: Workout_Share_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't share the image.`)
};

const pt_br2_workout_share_share_failed = /** @type {(inputs: Workout_Share_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para compartilhar a imagem.`)
};

const es_419_workout_share_share_failed = /** @type {(inputs: Workout_Share_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo compartir la imagen.`)
};

const pt_pt2_workout_share_share_failed = /** @type {(inputs: Workout_Share_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível partilhar a imagem.`)
};

const fr_fr2_workout_share_share_failed = /** @type {(inputs: Workout_Share_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de partager l'image.`)
};

const de_de2_workout_share_share_failed = /** @type {(inputs: Workout_Share_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Bild konnte nicht geteilt werden.`)
};

const it_it2_workout_share_share_failed = /** @type {(inputs: Workout_Share_Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile condividere l'immagine.`)
};

/**
* | output |
* | --- |
* | "Couldn't share the image." |
*
* @param {Workout_Share_Share_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_share_failed = /** @type {((inputs?: Workout_Share_Share_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Share_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_share_failed(inputs)
	if (locale === "es-419") return es_419_workout_share_share_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_share_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_share_failed(inputs)
	if (locale === "de-DE") return de_de2_workout_share_share_failed(inputs)
	if (locale === "it-IT") return it_it2_workout_share_share_failed(inputs)
	return en_us2_workout_share_share_failed(inputs)
});
export { workout_share_share_failed as "workout-share.share_failed" }